import {
    Grid,
    Button,
    Typography,
    Paper,
} from "@material-ui/core";
import moment from "moment-timezone";
import React, { useState, useEffect } from "react";
import DynamicTable from "./DynamicTable";
import { certficateTableHeader } from './constants'
import services from "../../Services";
import { CertificateModal } from "../../Imports/ModalImports"
import { CheckExpiry, changeDateFormat } from "../../helpers/textValidation";
const {
    hr
} = services;




const CertificateTable = ({ tableData }) => {


    let { employeeId, employeeDetails, flag, setFlag } = tableData

    const [certificate, setCertificate] = useState([])
    const [updateCertificate, setUpdateCertificate] = useState({})
    const [updatedCertificateID, setUpdatedCertificateID] = useState('')
    const [updatedCertificateName, setUpdatedCertificateName] = useState('default_license')
    const [updatedCertificateIssueDate, setUpdatedCertificateIssueDate] = useState('')
    const [updatedCertificateExpiryDate, setUpdatedCertificateExpiryDate] = useState('')
    const [addCertificate, setAddCertificate] = useState(false);
    const [selectedCertificateType, setSelectedCertificateType] = useState('')
    const [certificateType, setCertificateType] = useState([])
    const [openCerti, setOpenC] = useState(false);

    useEffect(() => {
        try {
            hr.getCertificate({ id: employeeId }).then((certificateData) => {

                setCertificate(certificateData.data.rows)

                hr.getCertificateType().then((certificateData) => {

                    setCertificateType(certificateData?.data?.rows)


                }).catch((err) => { });


            }).catch((err) => { });

        }
        catch (exc) {

        }

    }, [flag])

    function getCertificate(row) {

        setUpdateCertificate(row)
        setUpdatedCertificateID(row.id)
        setSelectedCertificateType(row.CertificateTypeId);
        setUpdatedCertificateName(row.name);

        setUpdatedCertificateIssueDate(new Date(row.issue_date))
        setUpdatedCertificateExpiryDate(new Date(row.expiry_date))

        setOpenC(true);
    };

    const openCertificateModal = () => {
        setUpdateCertificate(null)
        setSelectedCertificateType(null)
        setUpdatedCertificateIssueDate(null)
        setUpdatedCertificateExpiryDate(null)
        setAddCertificate(true)
        setOpenC(true)
    }
    const handleCloseCerti = () => {
        setAddCertificate(false)
        setOpenC(false);
    };


    let table = {
        header: certficateTableHeader,
        rows: certificate.map(row => [
            row.id,
            row.name,
            changeDateFormat(row.issue_date),
            CheckExpiry(changeDateFormat(row?.expiry_date).split('-')) == false ? <p className="testExpiry">{changeDateFormat(row?.expiry_date)}</p> : changeDateFormat(row?.expiry_date),
            <Button onClick={() => getCertificate(row)} className="EditIcon"></Button>
        ])
    }

    let certificateData = {
        employeeDetails: employeeDetails,
        updateCertificate: updateCertificate,
        open: openCerti,
        certificateType,
        updatedCertificateID,
        updatedCertificateIssueDate,
        setUpdatedCertificateIssueDate,
        updatedCertificateExpiryDate,
        setUpdatedCertificateExpiryDate,
        close: handleCloseCerti,
        setOpenC,
        setAddCertificate,
        setSelectedCertificateType,
        selectedCertificateType,
        setUpdatedCertificateName,
        updatedCertificateName,
        certifcateadd: addCertificate,
        mainFlag: flag,
        setMainFlag: setFlag
    }

    return (
        <>
            <Grid xs={14} className="">


            <Grid container alignItems="center" justifyContent="space-between" style={{marginBottom:'10px'}}>
                    <Grid xs={8}>
                    <Button for="selecteSertificate" className="LinkButton" onClick={openCertificateModal}>
                            Add Certificate & License
                        </Button>
                    </Grid>
                   
                </Grid>

                <Paper>
                </Paper>
            </Grid>

            <Grid xs={12} >
                <DynamicTable tableData={table} />


            </Grid>

            <CertificateModal certficateModall={certificateData} />
        </>

    )
}

export default CertificateTable